module.exports = __webpack_public_path__ + "static/media/cd-ferdinand.9a010457.jpg";